<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="5">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col lg="2" cols="1" align="start">
                <v-btn fab text small color="grey darken-2" @click="prev">
                  <v-icon>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col lg="8" cols="10" v-if="calendarInitialized" align="center">
                {{ calendarTitle }}
              </v-col>
              <v-col lg="2" cols="1" align="end">
                <v-btn fab text small color="grey darken-2" @click="next">
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-calendar :locale="$i18n.locale" :value="selectedMonth" @click:date="selectDate" ref="calendar">
              <template v-slot:day="{ date }">
                <div style="height: 30px">
                  <div v-if="eventsByDate(date).count > 0">
                    <template v-for="(category, index) in eventsByDate(date).categories">
                      <v-icon
                          :key="category"
                          small
                          :color="categoryColors[category]"
                          :style="eventsByDate(date).categories.length > 1 && index  >= 1?'margin-left:2px':''"
                      >
                        mdi-tag
                      </v-icon>
                    </template>
                  </div>
                </div>
              </template>
            </v-calendar>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="7">
        <v-card>
          <v-card-title>{{ selectedDate !== null ? $t('event_list') : $t('upcoming_event_list') }}
            <div v-if="selectedDate !== null" class="pl-1">(
              <v-icon>mdi-calendar-month</v-icon>
              {{ selectedDate.date }} )
              <v-tooltip  right bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="clearSelect"
                          v-bind="attrs"
                          v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span>{{ $t('display_upcoming_event') }}</span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="upcomingEvents.length > 0 && selectedDate === null">
            <v-list>
              <template v-for="(event, index) in upcomingEvents">
                <v-list-item :key="index">
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-list-item-avatar class="custom-avatar">
                        <v-img :alt="event.title" :src="event.cover_image"
                        ></v-img>
                      </v-list-item-avatar>
                    </v-col>
                    <v-col cols="10" md="8">
                      <v-list-item-content>
                        <v-list-item-title class="title" :wrap="true">{{ event.title }}</v-list-item-title>
                        <v-list-item-subtitle class="subtitle">
                          <div>
                                              <span>
                                              <v-icon small> mdi-calendar-month</v-icon>
                                              {{ event.date }} |
                                              <v-icon small :color="categoryColors[event.category]"> mdi-tag</v-icon>
                                              {{ $t(event.category) }}
                                              </span>
                          </div>
                          <div>
                                              <span>
                                              <v-icon small> mdi-school</v-icon>
                                              {{ event.school }}
                                              </span>
                          </div>
                          <div v-if="event.description" class="event-description">{{ event.description }}</div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="2" md="1">
                      <v-btn icon @click="redirectToEvent(event.url)" target="_blank">
                        <v-icon color="grey lighten-1">mdi-location-enter</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="py-2"></v-divider>
              </template>
            </v-list>
          </v-card-text>

          <v-card-text v-else-if="selectedDateEvents.length > 0">
            <v-list>
              <template v-for="(event, index) in selectedDateEvents">
                <v-list-item :key="index">
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-list-item-avatar class="custom-avatar">
                        <v-img :alt="event.title" :src="event.cover_image"
                        ></v-img>
                      </v-list-item-avatar>
                    </v-col>
                    <v-col cols="10" md="8">
                      <v-list-item-content>
                        <v-list-item-title class="title" :wrap="true">{{ event.title }}</v-list-item-title>
                        <v-list-item-subtitle class="subtitle">
                          <div>
                                              <span>
                                              <v-icon small> mdi-calendar-month</v-icon>
                                              {{ event.date }} |
                                              <v-icon small :color="categoryColors[event.category]"> mdi-tag</v-icon>
                                              {{ $t(event.category) }}
                                              </span>
                          </div>
                          <div>
                                              <span>
                                              <v-icon small> mdi-school</v-icon>
                                              {{ event.school }}
                                              </span>
                          </div>
                          <div v-if="event.description" class="event-description">{{ event.description }}</div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="2" md="1">
                      <v-btn icon @click="redirectToEvent(event.url)" target="_blank">
                        <v-icon color="grey lighten-1">mdi-location-enter</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="py-2"></v-divider>
              </template>
            </v-list>
          </v-card-text>
          <v-card-text v-else>
            {{ $t('no_events') }}
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <div class="text-right">
              <div class="badge-box">
                <v-icon class="pr-1" small :color="categoryColors['activities']"> mdi-tag</v-icon>
                {{ $t('activities') }}
              </div>
              <div class="badge-box">
                <v-icon class="pr-1" small :color="categoryColors['media-report']"> mdi-tag</v-icon>
                {{ $t('media-report') }}
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      selectedMonth: new Date(),
      selectedDate: null,
      allEvents: [],
      upcomingEvents: [],
      selectedDateEvents: [],
      calendarInitialized: false,
      currentLocale: null,
      categoryColors: {
        activities: '#087e58',
        'media-report': '#00b0c9'
      }
    };
  },
  computed: {
    calendarTitle() {
      if (this.$refs.calendar) {
        return this.$refs.calendar.title;
      }
      return '';
    },
  },
  async created() {
    this.currentLocale = this.mapLanguage(this.$i18n.locale);
    await this.fetchEvents(); // Wait for fetchEvents to complete
    await this.fetchEvents('upcoming')
    //const formattedDate = new Date().toISOString().split('T')[0];
    //console.log(this.events)
    //this.selectDate({date: formattedDate});
  },
  mounted() {
    // Set calendarInitialized to true after the calendar component is mounted
    this.calendarInitialized = true;
  },
  methods: {
    async fetchEvents(date = 'all') {
      await axios
          .get('https://www.poleungkuk.org.hk/' + this.currentLocale + '/activity/getAllEvents/' + date)
          .then(response => {
            if (date === 'all')
              this.events = response.data;
            else if (date === 'upcoming')
              this.upcomingEvents = response.data;
          })
          .catch(error => {
            // eslint-disable-next-line
            console.error('Error fetching events:', error);
          });
    },
    eventsByDate(date) {
      //console.log(date);
      if (!this.events) return {count: 0, categories: []}; // Return 0 if events are not available

      // Ensure date is a Date object
      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      // Get the year, month, and day of the current cell's date
      const cellYear = date.getFullYear();
      const cellMonth = date.getMonth();
      const cellDay = date.getDate();

      // Filter events only if events array is not null or undefined
      if (Array.isArray(this.events)) {
        // Filter events that match the current cell's date
        const eventsOnDate = this.events.filter(event => {
          const eventDate = new Date(event.date);
          return (
              eventDate.getFullYear() === cellYear &&
              eventDate.getMonth() === cellMonth &&
              eventDate.getDate() === cellDay
          );
        });

        let categories = [];

        if (eventsOnDate.length) {

          //console.log(eventsOnDate.map(e => e.category))
          categories = [...new Set(
              eventsOnDate.map(e => e.category)
          )];

        }

        return {
          count: eventsOnDate.length,
          categories
        }
      } else {
        return {
          count: 0,
          categories: []
        }; // Return 0 if events are not available or not an array
      }
    },
    async selectDate(selectedDate) {
      //console.log('Date',selectedDate)
      if (selectedDate && selectedDate.date) {
        const dateString = selectedDate.date;
        this.selectedDateEvents = this.events.filter(event => event.date === dateString);
        this.$emit('date-selected', selectedDate);
        this.selectedDate = selectedDate;
      } else {
        // eslint-disable-next-line
        console.error('Invalid date:', selectedDate);
      }
    },
    clearSelect() {
      this.selectedDate = null;
      this.selectedDateEvents = [];
    },
    redirectToEvent(url) {
      // Redirect to the event URL in the same window
      window.open(url, '_blank');
    },
    mapLanguage(lang) {
      switch (lang) {
        case 'zh-hk':
          return 'tc';
        case 'zh-cn':
          return 'sc';
        default:
          return lang; // For 'en' or other languages, return the same code
      }
    },
    async prev() {
      const d = new Date(this.selectedMonth);
      d.setMonth(d.getMonth() - 1);
      await this.fetchEvents();
      this.selectedMonth = d;
    },
    async next() {
      const d = new Date(this.selectedMonth);
      d.setMonth(d.getMonth() + 1);
      this.selectedMonth = d;
      await this.fetchEvents();
    },
  },
};
</script>
<style scoped>
.title {
  text-align: left; /* Align title to the left */
}

.subtitle {
  text-align: left; /* Align subtitle to the left */
  font-weight: bold;
}

.v-avatar {
  min-width: 100% !important;
  height: auto !important;
  border-radius: 2px !important;
}


.event-description {
  margin-top: 6px;
  width: 100%;
  white-space: initial;
  text-align: justify;
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

}

.event-description:hover {
  overflow: visible;
  display: block;
  height: auto;
}

.badge-box {
  position: relative;
  display: inline-flex;
  padding: 0 16px;
}

.text-right {
  justify-content: flex-end !important;
}

.v-list-item__subtitle, .v-list-item__title {
  white-space: normal;
}

/deep/ .badge-box .v-badge {
  position: absolute;
}

/deep/ .badge-square .v-badge__badge {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 !important;
  width: 12px !important;;
  height: 12px !important;;
}

/* Targeting elements inside v-calendar */
/deep/ .v-calendar .v-calendar-weekly__day.v-past.v-outside {
  background-color: #eafdef !important;
}

/deep/ .v-calendar .v-calendar-weekly__day.v-future.v-outside {
  background-color: #eafdef !important;
}

/deep/ .v-calendar-weekly__day.v-present .theme--light.v-btn.v-btn--has-bg {
  background-color: #dffce7 !important;
}

/deep/ .v-calendar-weekly__head-weekday {
  background-color: #00a489 !important;
  color: white !important;
}

/deep/ .v-divider.theme--light {
  margin: 0;
}
</style>

<style>
.container {
  width: 100%;
  padding: 0 15px !important;
}

/* Global styles affecting the whole website */
@media only screen and (min-width: 768px) {
  .container {
    width: 750px !important;
  }
}

@media only screen and (min-width: 992px) {
  .container {
    width: 970px !important;
  }
}

@media only screen and (min-width: 1200px) {
  .container {
    width: 1170px !important;
  }
}
</style>